import { render, staticRenderFns } from "./staffTree.vue?vue&type=template&id=8fd6e7e6&scoped=true&"
import script from "./staffTree.vue?vue&type=script&lang=js&"
export * from "./staffTree.vue?vue&type=script&lang=js&"
import style0 from "./staffTree.vue?vue&type=style&index=0&id=8fd6e7e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd6e7e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8fd6e7e6')) {
      api.createRecord('8fd6e7e6', component.options)
    } else {
      api.reload('8fd6e7e6', component.options)
    }
    module.hot.accept("./staffTree.vue?vue&type=template&id=8fd6e7e6&scoped=true&", function () {
      api.rerender('8fd6e7e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/staffTree/staffTree.vue"
export default component.exports